import { useTranslation } from "react-i18next"

import type { LucideIcon } from "@/components/icons"

import { ChevronRight, FileDown, Languages, Upload } from "@/components/icons"

type WorkflowStep = {
  index: number
  icon: LucideIcon
  titleKey: string
  descriptionKey: string
}

const STEPS: ReadonlyArray<WorkflowStep> = [
  {
    index: 1,
    icon: Upload,
    titleKey: "workflow_step_1_title",
    descriptionKey: "workflow_step_1_description",
  },
  {
    index: 2,
    icon: Languages,
    titleKey: "workflow_step_2_title",
    descriptionKey: "workflow_step_2_description",
  },
  {
    index: 3,
    icon: FileDown,
    titleKey: "workflow_step_3_title",
    descriptionKey: "workflow_step_3_description",
  },
] as const

export function DemoTranslatorWorkflow() {
  const { t } = useTranslation("", { keyPrefix: "training.ai-translator.introduction" })

  return (
    <div className="w-full">
      <div className="flex flex-col items-stretch gap-3 sm:flex-row sm:items-center sm:gap-2">
        {STEPS.map(({ index, icon: Icon, titleKey, descriptionKey }, i) => (
          <div key={index} className="flex flex-1 items-center gap-2">
            <div className="bg-background flex flex-1 flex-col items-center gap-2 rounded-xl border p-4 text-center">
              <div className="bg-primary/10 text-primary flex h-10 w-10 items-center justify-center rounded-full">
                <Icon className="size-5" />
              </div>
              <div className="text-muted-foreground text-[10px] font-semibold tracking-wide uppercase">
                {t("workflow_step_label", { defaultValue: "Steg" })} {index}
              </div>
              <p className="text-sm font-semibold">{t(titleKey)}</p>
              <p className="text-muted-foreground text-xs">{t(descriptionKey)}</p>
            </div>
            {i < STEPS.length - 1 && (
              <ChevronRight className="text-muted-foreground hidden size-5 shrink-0 sm:block" />
            )}
          </div>
        ))}
      </div>
    </div>
  )
}
